// extracted by mini-css-extract-plugin
module.exports = {"banner":"Registor_banner__8aRrW","itemsOnBanner":"Registor_itemsOnBanner__2l_C6","countDown":"Registor_countDown__3jhF0","registor":"Registor_registor__3-RZB"};